import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import CategoryPage from "./pages/CategoryPage";
import Realisations from "./pages/Realisations";
import Devis from "./pages/Devis";
import Contact from "./pages/Contact";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const BRAND_LOGO =
  "https://customer-assets-jt897jd0.emergentagent.net/job_sweet-creations-pk/artifacts/3v47fawl_EB68074F-75D8-4CBF-BF34-21D942A41F55.webp";

function App() {
  useEffect(() => {
    const applyMeta = () => {
      document.title = "Rimpatisse | L'art de la gourmandise";
      let link = document.querySelector("link[rel='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.type = "image/webp";
      link.href = BRAND_LOGO;
    };
    applyMeta();
    // Re-apply shortly after in case an external script overrides the title
    const t = setTimeout(applyMeta, 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="App font-body">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/a-propos" element={<About />} />
            <Route path="/gateaux" element={<CategoryPage categoryKey="gateaux" />} />
            <Route path="/cupcakes-desserts" element={<CategoryPage categoryKey="cupcakes-desserts" />} />
            <Route path="/cookies" element={<CategoryPage categoryKey="cookies" />} />
            <Route path="/trompe-loeil" element={<CategoryPage categoryKey="trompe-loeil" />} />
            <Route path="/mes-realisations" element={<Realisations />} />
            <Route path="/devis" element={<Devis />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
